import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import ScrollToTop from "../../components/shared/ScrollToTop/ScrollToTop";
import "./PublicLayout.css";

const PublicLayout = () => {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div key={location.pathname} className="public-layout__page">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default PublicLayout;
